"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _StagedObject = _interopRequireDefault(require("redux-less/StagedObject"));

var _constants = require("settings-ui-sdk/SubscriptionDefinitions/constants");

var properties = [_constants.ACTIVE, _constants.DESCRIPTION, _constants.NAME, _constants.INTERNAL, _constants.PROCESS, _constants.OPERATION, _constants.TRANSLATIONS];
var UpdateType = new _StagedObject.default({
  domainSelector: function domainSelector(state) {
    return state;
  },
  stagedSelector: function stagedSelector(state) {
    return state.modules.marketing.email.staging.updateType;
  },
  namespace: 'email',
  objectType: 'UpdateType',
  properties: properties
});
var _default = UpdateType;
exports.default = _default;
module.exports = exports.default;